import React from "react";
import Player, { RHAP_UI } from "react-h5-audio-player";

import "react-h5-audio-player/lib/styles.css";
import "./AudioPlayer.css";

function AudioPlayer({ url }: { url: string }) {
  return (
    <div
      className="player-view"
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 100,
      }}
    >
      <Player
        autoPlay
        src={url}
        onPlay={(e) => console.log("onPlay")}
        layout="horizontal-reverse"
        customIcons={{
          rewind: (
            <img
              height={20}
              width={20}
              src="./assets/player_rewind.svg"
              alt="rewind"
            />
          ),
          forward: (
            <img
              height={20}
              width={20}
              src="./assets/player_forward.svg"
              alt="forward"
            />
          ),
          pause: (
            <img height={30} width={30} src="./assets/pause.svg" alt="pause" />
          ),
          play: (
            <img
              height={30}
              width={30}
              src="./assets/play.svg"
              alt="playButton"
            />
          ),
        }}
        // customControlsSection={[
        //   RHAP_UI.MAIN_CONTROLS,
        //   RHAP_UI.ADDITIONAL_CONTROLS,
        //   RHAP_UI.PROGRESS_BAR,
        //   RHAP_UI.VOLUME_CONTROLS,
        // ]}
        // customProgressBarSection={[]}
        customAdditionalControls={[]}
        customVolumeControls={[]}
      />
    </div>
  );
}

export default AudioPlayer;
